export const BANNER_VISIBILITY_TIMEOUT_S = 30 * 24 * 60 * 60; // 30 days
